import type { FC } from 'react';
import React from 'react';

import RibbonMessage from './RibbonMessage';
import Ribbon from './Ribbon/Ribbon';

const RibbonWithMessage: FC = () => {
  return (
    <Ribbon
      ribbonOrientation="right"
      ribbonPlacement="summary"
      mobileProperties={{
        content: { paddingNoRibbonSide: 'big', paddingRibbonSide: 'base' },
      }}
    >
      <RibbonMessage withIcon={true} placement="summary" />
    </Ribbon>
  );
};

export default RibbonWithMessage;
